import React, { useState }  from 'react'
import plus from '../assets/+.svg'

function AddContractForm({ setRefresh, setOpenPopup, setLoading, taskID, category}) {
    const [name, setName] = useState('');
    const [value, setValue] = useState('0.00');
    function isFloat(value) {
      // Regular expression to match a floating-point number
      const floatRegex = /^[+-]?\d+(\.\d+)?$/;
    
      return floatRegex.test(value);
    }
    const handleSubmit = (e) => {
      console.log(value, name)
        e.preventDefault();
        if(!isFloat(parseFloat(value.replace(/,/g, ''))))
        return;
        if(name.length ===0 ) return;
        setOpenPopup(false)
        setLoading(true)
        fetch('/api-dev/expenses/CreateMainBudgetLine',{
   method: "POST",
       body: JSON.stringify({TaskID:taskID, BudgetType:category, MainBudgetLineName:name, Value:parseFloat(value.replace(/,/g, ''))}),
        headers: {
          'Content-Type': 'application/json',
        },
     })
       
       .then(res =>{
        setName("")
        setValue('')
        setRefresh(prev => !prev)
        
        console.log("added in database")
       })
        console.log(name, parseFloat(value.replace(/,/g, '')));
    }
      const handleChangeValue = (e) => {
        /*const inputValue = parseFloat(e.target.value);
        setValue(inputValue);*/
        const rawValue = e.target.value.replace(/,/g, ''); // Remove commas for processing
        const formattedValue = rawValue
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        setValue(formattedValue);
      };
      const handleChangeName = (e) => {
        setName(e.target.value);
      }
    return (
        <>
        <form onSubmit={handleSubmit}>
            <div className='form-input'>
                <label className='form-input-label'>Contract title*</label>
                <input value={name} onChange={handleChangeName} className='form-input-field input' type="text" placeholder="Name" />
            </div>
            <div className='form-input' style={{marginTop:'30px'}}>
                <label className='form-input-label'>Allocated budget*</label>
                <input value={value} onChange={handleChangeValue} id="myNumberInput" className='form-input-field' type="text" placeholder="0,00" />
            </div>
            <div className='form-button' style={{marginTop:'40px'}}>
            <button style={{cursor:'pointer'}} type="submit" className='form-submit'>
                <img src={plus} alt="plus" className='form-submit-icon' />
                &nbsp;
                <span className='form-submit-text'>Create contract</span>
            </button>
            </div>
        </form>
            
        </>

    )
}

export default AddContractForm